import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import Menu from '../components/Menu'
import NotesMenu from '../components/NotesMenu'
import TopBarLayout from '../layouts/TopBarLayout'
import ui from '../stores/ui'

class SessionLayout extends Component {
  render() {
    const { title, children, match, demo, phoneSession } = this.props
    const { session, patientID } = match.params

    return (
      <Fragment>
        <Menu icon="fas fa-bars">
          <Menu.Logo />
          <Menu.Divider />

          { demo && !phoneSession && <Menu.Link to="/demo/learn" str="titles.learn" icon="fas fa-graduation-cap" /> }
          { demo && !phoneSession && <Menu.Link to="/demo/use" str="titles.use" icon="fas fa-eye-dropper" /> }
          { demo && !phoneSession && <Menu.Link to="/demo/goal" str="titles.goal" icon="fas fa-thumbs-up" /> }
          { demo && !phoneSession && <Menu.Link to="/demo/plan" str="titles.plan" icon="fas fa-calendar-check" /> }
          { demo && !phoneSession && <Menu.Divider /> }
          { demo && !phoneSession && <Menu.LanguageSwitcher /> }
          { demo && !phoneSession && <Menu.QuitLink to="/" str="titles.endSession" icon="fas fa-chevron-left" /> }
        
          { !demo && !phoneSession && session !== 'second' && <Menu.Link to={`/learn/${session}/${patientID}`} str="titles.learn" icon="fas fa-graduation-cap" />}
          { !demo && !phoneSession && <Menu.Link to={`/use/${session}/${patientID}`} str="titles.use" icon="fas fa-eye-dropper" /> }
          { !demo && !phoneSession && <Menu.Link to={`/goal/${session}/${patientID}`} str="titles.goal" icon="fas fa-thumbs-up" /> }
          { !demo && !phoneSession && <Menu.Link to={`/plan/${session}/${patientID}`} str="titles.plan" icon="fas fa-calendar-check" /> }
          { !demo && !phoneSession && <Menu.Divider /> }
          { !demo && !phoneSession &&
            <Menu.Link
              dontCloseMenu={true}
              str="Should prompts be shown?"
              icon={ui.promptsHidden ? "fas fa-toggle-off" : "fas fa-toggle-on"}
              onClick={ui.togglePrompts}
            />
          }
          { !demo && !phoneSession && !ui.promptsHidden &&
            <Menu.Link
              dontCloseMenu={true}
              str="Force all prompts to be open?"
              icon={ui.allPromptsOpen ? "fas fa-toggle-on" : "fas fa-toggle-off"}
              onClick={ui.toggleAllPromptsOpen}
            />
          }
          { !demo && !phoneSession && <Menu.Divider /> }
          { !demo && !phoneSession && <Menu.LanguageSwitcher /> }
          {/* { !demo && !phoneSession && <Menu.QuitLink to={`/edit-patient/${patientID}`} str="titles.endSession" icon="fas fa-chevron-left" /> } */}

          { phoneSession && <Menu.LanguageSwitcher /> }
          { phoneSession && <Menu.QuitLink to={`/edit-patient/${patientID}`} str="titles.endSession" icon="fas fa-chevron-left" /> }
        </Menu>
        <NotesMenu />
        <TopBarLayout title={title}>
          {children}
        </TopBarLayout>
      </Fragment>
    )
  }
}

export default withRouter(SessionLayout)



// WEBPACK FOOTER //
// ./src/layouts/SessionLayout.js